if (!customElements.get('card-variant-picker')) {
  customElements.define(
    'card-variant-picker',
    class CardVariantPicker extends HTMLElement {
      constructor() {
        super();
        this.select = this.querySelector('.card-quick-variant__select');
        this.input = this.querySelector('.product-variant-id');
        this.button = this.querySelector('.card-quick-variant__add');
        this.form = this.querySelector('form');
        this.errorEl = this.querySelector('.card-quick-variant__error');
        this.priceEl = null;

        const wrapper = this.closest('.card-wrapper');
        if (wrapper) this.priceEl = wrapper.querySelector('.price');

        if (this.select) {
          this.select.addEventListener('change', this.onVariantChange.bind(this));
          this.onVariantChange();
        }

        if (this.form) {
          this.form.addEventListener('submit', this.onSubmit.bind(this));
        }
      }

      get selectedOption() {
        return this.select.options[this.select.selectedIndex];
      }

      onVariantChange() {
        const option = this.selectedOption;
        if (!option) return;

        if (this.input) this.input.value = option.value;

        const available = option.dataset.available === 'true';
        if (this.button) {
          this.button.disabled = !available;
          this.button.setAttribute('aria-disabled', available ? 'false' : 'true');
        }

        this.hideError();
        this.updatePrice(option);
      }

      updatePrice(option) {
        if (!this.priceEl) return;

        const price = option.dataset.price || '';
        const compare = option.dataset.compare || '';
        const onSale = option.dataset.onSale === 'true';

        this.priceEl.classList.toggle('price--on-sale', onSale);

        const regular = this.priceEl.querySelector('.price__regular .price-item--regular');
        if (regular) regular.textContent = price;

        const saleItem = this.priceEl.querySelector('.price__sale .price-item--sale');
        if (saleItem) saleItem.textContent = price;

        const compareItem = this.priceEl.querySelector('.price__sale .price-item--regular');
        if (compareItem) compareItem.textContent = onSale ? compare : price;
      }

      /* ---- Add to cart without leaving the page ---- */

      onSubmit(evt) {
        evt.preventDefault();
        if (!this.button || this.button.disabled || this.button.classList.contains('is-loading')) return;

        this.hideError();
        this.setLoading(true);

        const cartDrawer = document.querySelector('cart-drawer');
        const cartNotification = document.querySelector('cart-notification');
        const cartTarget = cartDrawer || cartNotification;

        const formData = new FormData(this.form);
        formData.delete('card-variant');

        let sectionIds = ['cart-icon-bubble'];
        if (cartTarget && typeof cartTarget.getSectionsToRender === 'function') {
          sectionIds = cartTarget.getSectionsToRender().map((section) => section.id);
        }
        formData.append('sections', sectionIds.join(','));
        formData.append('sections_url', window.location.pathname);

        fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData,
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.showError(response.description || response.message || '');
              return;
            }

            if (cartTarget && typeof cartTarget.renderContents === 'function') {
              if (cartNotification && !cartDrawer && typeof cartNotification.setActiveElement === 'function') {
                cartNotification.setActiveElement(document.activeElement);
              }
              cartTarget.renderContents(response);
            } else {
              this.updateCartBubble(response.sections);
            }

            this.flashAdded();
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          })
          .catch(() => {
            this.showError('');
          })
          .finally(() => {
            this.setLoading(false);
          });
      }

      updateCartBubble(sections) {
        if (!sections || !sections['cart-icon-bubble']) return;
        const target = document.getElementById('cart-icon-bubble');
        if (!target) return;
        const html = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        const source = html.querySelector('#shopify-section-cart-icon-bubble') || html.querySelector('.shopify-section');
        if (source) target.innerHTML = source.innerHTML;
      }

      setLoading(state) {
        if (!this.button) return;
        this.button.classList.toggle('is-loading', state);
        const spinner = this.button.querySelector('.loading__spinner');
        if (spinner) spinner.classList.toggle('hidden', !state);
      }

      flashAdded() {
        if (!this.button) return;
        this.button.classList.add('is-added');
        window.setTimeout(() => this.button.classList.remove('is-added'), 1600);
      }

      showError(message) {
        if (!this.errorEl) return;
        this.errorEl.textContent = message || 'Could not add to cart.';
        this.errorEl.classList.add('is-visible');
      }

      hideError() {
        if (!this.errorEl) return;
        this.errorEl.textContent = '';
        this.errorEl.classList.remove('is-visible');
      }
    }
  );
}
